import { createSlice } from "@reduxjs/toolkit";

const gallerySlice = createSlice({
  name: "gallerySlice",
  initialState: {
    screenshotData: null,
  },
  reducers: {
    setScreenshotData: (state, action) => {
      state.screenshotData = action?.payload;
    },
    clearNudity: (state, action) => {
      state.screenshotData = null;
    },
  },
});

// this is for dispatch
export const { screenshotData, clearNudity } = gallerySlice.actions;

// this is for configureStore
export default gallerySlice.reducer;
